<template>
  <div>
    <v-dialog v-model="exibir" width="1000" max-width="90vw">
      <v-card style="max-width: 100%">
        <v-toolbar color="blue" class="mb-8">
          <v-flex style="display: flex" class="pa-2">
            <span style="width:95%;color:white;font-weight:bold;">
              Histórico de Integração Omie
            </span>
            <span style="width:5%;">
              <v-btn x-small color="red" @click="() => fecharModal()" title="Fechar">
                <v-icon x-small style="color:white;">mdi-close</v-icon>
              </v-btn>
            </span>
          </v-flex>
        </v-toolbar>

        <v-card-text>
          <v-data-table :headers="headers" :items="items" :loading="carregando" no-data-text="Sem eventos de integração Omie" dense>
            <template v-slot:item.datahora="{ item }">
              {{ formatarData(item.datahora) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const dayjs = require('dayjs')

export default {
  name: 'ModalLogOmie',
  props: ['exibirModal', 'idcomanda', 'idcomandaproduto'],
  data: () => ({
    carregando: false,
    items: [],
    headers: [
      { text: 'Data/Hora', value: 'datahora' },
      { text: 'Tipo', value: 'tipo_operacao' },
      { text: 'Status', value: 'status_operacao' },
      { text: 'Origem', value: 'origem_operacao' },
      { text: 'Qtd. movimentada', value: 'quantidade_movimentada' },
      { text: 'Motivo falha', value: 'motivo_falha' },
    ],
  }),
  computed: {
    exibir: {
      get() { return this.exibirModal },
      set(valor) { if (!valor) this.fecharModal() },
    },
  },
  watch: {
    exibirModal(valor) {
      if (valor) this.buscarLogs()
    },
  },
  methods: {
    fecharModal() {
      this.$emit('fechar')
    },
    formatarData(data) {
      return data ? dayjs(data).format('DD/MM/YYYY HH:mm:ss') : ''
    },
    buscarLogs() {
      if (!this.idcomanda) return
      this.carregando = true
      this.$http.get(`pdv/omie/logs/${this.idcomanda}`, { params: this.idcomandaproduto ? { idcomandaproduto: this.idcomandaproduto } : {} })
        .then(resp => { this.items = resp.data || [] })
        .catch(error => { console.log(error) })
        .finally(() => { this.carregando = false })
    },
  },
}
</script>

<style scoped>
</style>
